<template>
  <div class="container">
    <div class="container__inner container__inner--min exhibition">
      <h2 class="contentTitle contentTitle--center">研究紹介</h2>
    </div>
    <div class="container__inner">
      <div class="exhibition__cont exhibitList" id="o-exhibits">
        <router-link
          class="exhibitCont"
          v-for="article in articles"
          :key="article.id"
          :to="{name: 'ExhibitItem', params: {exhibitId: article.id, studentNo: article.acf.student_number}}"
        >
          <div class="exhibitPlace">
            <p>{{article.acf.exhibit_place[0]}}</p>
            <p>{{article.acf.exhibit_place[1]}}</p>
          </div>
          <img :src="article.acf.research_photo02" alt>
          <p class="exhibitCont__name__furigana">{{article.acf.student_name_furigana}}</p>
          <p class="exhibitCont__name">{{article.acf.student_name}}</p>
          <p class="exhibitCont__catch">{{article.acf.exhibit_copy}}</p>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
// import ExhibitsListTemplate from '@/components/Templates/ExhibitsList'
import axios from 'axios'

export default {
  name: 'o-exhibits',
  data: function () {
    return {
      articles: []
    }
  },
  methods: {
    fetchArticles: function () {
      axios.get('https://fundesign.jp/sotsuten2019/wordpress/wp-json/wp/v2/products?per_page=50').then((response) => {
        this.articles = response.data
      }, (error) => {
        console.log(error)
      })
    }
  },
  mounted: function () {
    this.fetchArticles()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$white: #fff;
$yellow: #eddb44;
$blue: #009898;

.container {
  margin-top: calc(72px + 80px);
  @media screen and (min-width: 769px) and (max-width: 960px) {
  }
  @media screen and (min-width: 412px) and (max-width: 768px) {
    margin-top: calc(32px + 56px);
  }
  @media screen and (max-width: 411px) {
    margin-top: calc(32px + 40px);
  }
}

.exhibitCont {
  display: block;
  width: calc((100% - 32px) / 3);
  color: inherit;
  font-size: 14px;
  text-decoration: none;
  transition: all .4s;
  letter-spacing: 0.1em;
  padding: 16px 8px;
  margin-bottom: 40px;
  &:hover {
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.2);
  }
  img {
    display: block;
    width: 100%;
  }
  .exhibitPlace {
    display: flex;
    margin-bottom: 8px;
    p {
      padding: 8px;
      border: solid 1px #dfdfdf;
      &:last-child {
        margin-left: 8px;
      }
      &:empty {
        display: none;
      }
    }
  }
  &:not(:nth-child(3n + 1)) {
    margin-left: 16px;
  }
  &__name {
    font-size: 18px;
    font-weight: bold;
    margin-top: 4px;
    &__furigana {
      font-size: 10px;
      margin-top: 16px;
    }
  }
  &__catch {
    font-size: 14px;
    margin-top: 8px;
    line-height: 1.5;
  }
  @media screen and (min-width: 769px) and (max-width: 960px) {
  }
  @media screen and (min-width: 415px) and (max-width: 768px) {
    width: calc((100% - 16px) / 2);
    &:not(:nth-child(3n + 1)) {
      margin-left: 0;
    }
    &:not(:nth-child(2n + 1)) {
      margin-left: 16px;
    }
  }
  @media screen and (max-width: 414px) {
    width: 100%;
    &:not(:nth-child(3n + 1)) {
      margin-left: 0;
    }
    margin-bottom: 24px;
  }
}

.exhibitList {
  display: flex;
  flex-wrap: wrap;
}
a {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/Exhibits/index.vue